<template>
<div>
  <div style="color: white;height:20px;line-height:20px;margin: 0 10px;font-size: 12px">
    <el-row>
      <el-col :span="24">
        客服在线数：{{customeronlinecount}}
      </el-col>
<!--      <el-col :span="12">-->
<!--        律师在线数：{{lawercount}}-->
<!--      </el-col>-->
    </el-row>
  </div>
  <div style="margin: 0 10px;height: calc(100% - 30px);overflow-y: auto">
    <el-table
      class="handle-list"
      :header-cell-style="getBackgroundColor"
      :row-class-name="tableRowClassName"
      :cellStyle="cellStyle"
      :data="tableData"
      style="width: 100%"
      size="mini">
      <el-table-column
        prop="customername"
        label="名称"
        min-width="55"
        :resizable="true"
        align="center">
      </el-table-column>
      <el-table-column
        prop="customeronlinetm"
        label="在线时间"
        min-width="85"
        :resizable="true"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</div>
</template>

<script>
export default {
  name: 'indexCustomerOnline',
  data () {
    return {
      customeronlinecount: 0,
      lawercount: 0,
      tableData: [
        {customername: '', customeronlinetm: ''}
      ]
    }
  },
  created () {
    // 客服在线人数
  },
  methods: {
    getLawyerCount (num) {
      this.lawercount = num
    },
    getCustomerCount (num) {
      this.customeronlinecount = num
    },
    getTableData (arr) {
      // console.log('law', arr)
      if (arr.length === 0) {
        this.tableData = [{customername: '', customeronlinetm: ''}]
      } else {
        this.tableData = arr
      }
    },
    cellStyle ({row, column, rowIndex, columnIndex}) {
      return 'border-color:#1a1a1a!important;font-weight:bold!important'
    },
    getBackgroundColor () {
      return {backgroundColor: '#13213a', color: '#00ffff', borderColor: '#1a1a1a'}
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexCustomerOnline.vue